interface LauncherSuppressionArgs {
  script: HTMLScriptElement;
  chatbot: string;
  tenant: string | null;
  widgetBase: string;
  documentRef?: Document;
  currentHref?: string;
}

const FALSEY_ATTRS = new Set(["0", "false", "no", "off"]);
const APP_MODES = new Set(["app", "fullscreen", "full-screen"]);

export function shouldSuppressLauncherForAppEmbed({
  script,
  chatbot,
  tenant,
  widgetBase,
  documentRef = document,
  currentHref = window.location.href,
}: LauncherSuppressionArgs): boolean {
  const launcherAttr = normalizedAttr(script, "data-launcher");
  if (launcherAttr && FALSEY_ATTRS.has(launcherAttr)) return true;

  const modeAttr =
    normalizedAttr(script, "data-mode") ||
    normalizedAttr(script, "data-widget-mode");
  if (modeAttr && APP_MODES.has(modeAttr)) return true;

  for (const iframe of Array.from(documentRef.querySelectorAll("iframe[src]"))) {
    const src = iframe.getAttribute("src");
    if (!src) continue;
    if (iframeIsMatchingAppEmbed(src, { chatbot, tenant, widgetBase, currentHref })) {
      return true;
    }
  }
  return false;
}

function normalizedAttr(script: HTMLScriptElement, name: string): string {
  return (script.getAttribute(name) || "").trim().toLowerCase();
}

function iframeIsMatchingAppEmbed(
  src: string,
  opts: {
    chatbot: string;
    tenant: string | null;
    widgetBase: string;
    currentHref: string;
  },
): boolean {
  try {
    const url = new URL(src, opts.currentHref);
    const expected = new URL(`${opts.widgetBase}/widget.html`, opts.currentHref);
    if (url.origin !== expected.origin || url.pathname !== expected.pathname) {
      return false;
    }
    if (url.searchParams.get("mode") !== "app") return false;
    if (url.searchParams.get("chatbot") !== opts.chatbot) return false;
    if (opts.tenant && url.searchParams.get("tenant") !== opts.tenant) return false;
    return true;
  } catch {
    return false;
  }
}
